/**
 * @generated SignedSource<<9c3ff714af84a4867da0be7a82593364>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type useSearchSuggestionsQuery$variables = {
  locale: string;
};
export type useSearchSuggestionsQuery$data = {
  readonly categories: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly context: any;
      };
    }>;
  };
  readonly templates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly contributor: {
          readonly __typename: "ContentPlatformAuthor";
          readonly name: string | null | undefined;
          readonly organization: {
            readonly name: string | null | undefined;
          } | null | undefined;
        } | {
          readonly __typename: "ContentPlatformOrganization";
          readonly name: string | null | undefined;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined;
        readonly name: string | null | undefined;
        readonly previewBlurb: string | null | undefined;
        readonly templateType: ReadonlyArray<{
          readonly id: string;
          readonly templateTypeName: string | null | undefined;
        }> | null | undefined;
        readonly urlSlug: string | null | undefined;
      };
    }>;
  };
};
export type useSearchSuggestionsQuery = {
  response: useSearchSuggestionsQuery$data;
  variables: useSearchSuggestionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locale"
  }
],
v1 = {
  "items": [
    {
      "kind": "Variable",
      "name": "withLocales.0",
      "variableName": "locale"
    }
  ],
  "kind": "ListValue",
  "name": "withLocales"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "items": [
              {
                "fields": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 200
                  },
                  (v1/*: any*/)
                ],
                "kind": "ObjectValue",
                "name": "queries.0"
              }
            ],
            "kind": "ListValue",
            "name": "queries"
          }
        ],
        "kind": "ObjectValue",
        "name": "search"
      }
    ],
    "concreteType": "ContentPlatformTemplateContentSearchConnection",
    "kind": "LinkedField",
    "name": "templates",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ContentPlatformTemplateResultEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplate",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlSlug",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "previewBlurb",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentPlatformTaxonomyTemplateType",
                "kind": "LinkedField",
                "name": "templateType",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "templateTypeName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "contributor",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v3/*: any*/),
                    "type": "ContentPlatformOrganization",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentPlatformOrganization",
                        "kind": "LinkedField",
                        "name": "organization",
                        "plural": false,
                        "selections": (v3/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "ContentPlatformAuthor",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": "categories",
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 25
      },
      {
        "kind": "Literal",
        "name": "forContentType",
        "value": "Template"
      },
      {
        "kind": "Literal",
        "name": "forFields",
        "value": [
          "category"
        ]
      },
      (v1/*: any*/)
    ],
    "concreteType": "ContentPlatformContentFacetConnection",
    "kind": "LinkedField",
    "name": "contentFacet",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ContentPlatformContentEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformContentFacet",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "context",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSearchSuggestionsQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSearchSuggestionsQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "c9eb57783afee61790d472617c9d9adb",
    "id": null,
    "metadata": {},
    "name": "useSearchSuggestionsQuery",
    "operationKind": "query",
    "text": "query useSearchSuggestionsQuery(\n  $locale: String!\n) {\n  templates(search: {queries: [{first: 200, withLocales: [$locale]}]}) {\n    edges {\n      node {\n        urlSlug\n        name\n        previewBlurb\n        templateType {\n          id\n          templateTypeName\n        }\n        contributor {\n          __typename\n          ... on ContentPlatformOrganization {\n            name\n          }\n          ... on ContentPlatformAuthor {\n            name\n            organization {\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n  categories: contentFacet(first: 25, forFields: [\"category\"], forContentType: \"Template\", withLocales: [$locale]) {\n    edges {\n      node {\n        context\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "372493189502e6e89c2d5588ed4b3bc2";

export default node;
